import React from 'react';
import './Hero.css';
import heroBg from '../assets/hero-bg.png';

function Hero() {
  return (
    <section className="hero" style={{ backgroundImage: `url(${heroBg})` }}>
      <div className="container">
        <h1>MAQUINARIA PANADERA <br /> DISEÑADA PARA PRODUCIR <br /> MAS Y MEJOR</h1>
        <p>Equipos robustos, precisos y confiables para panaderías que buscan crecer sin perder calidad.</p>

      </div>
    </section>
  );
}

export default Hero;
